export default __webpack_public_path__ + "db7ee342063165a073c24413e563673c.svg";